import mutations from './mutations';
import actions from './actions';
import getters from './getters';

import getInitialState from './initialState';

export default {
  namespaced: true,
  state: getInitialState(),
  mutations,
  actions,
  getters
};
